import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import './myChallenges.style.scss';
import Navbar from '../navbar/navbar.comp';
import MyChallenge from "../myChallenge/myChallenge.comp";
import { UserContext } from "../../contexts/user.context";
import { getMyChallengesForUser, deleteMyChallenge, updateMyChallenge } from "../../utils/firebase/firebase.utils";
import SmallButton from "../smallButton/smallButton.comp";
import Button from '../button/button.comp';
import { useChallenge } from "../../contexts/challenges.context";
import AddChallenge from "../addChallenge/addChallenge.comp.jsx";
import { initialChallenges } from "../../utils/initialObjects.comp.jsx";
import { formatFirestoreTimestamp } from "../../utils/dating.utils.js";
import ToggleSwitch from '../toggleSwitch/toggleSwitch.comp.jsx';


const MyChallenges = () => {

    //Nav & Contexts
    const navigate = useNavigate();
    const { userID } = useContext(UserContext);
    const { setSelectedChallenge } = useChallenge();


    //GET Challenges
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [challenges, setChallenges] = useState(initialChallenges);
    useEffect(() => {
        const timer = setTimeout(async () => {
            const loadedChallenges = await getMyChallengesForUser(userID);

            // Convert the datePosted object to a Date object and sort
            loadedChallenges.sort((a, b) => {
                const dateA = new Date(a.createdAt.seconds * 1000);
                const dateB = new Date(b.createdAt.seconds * 1000);
                return dateB - dateA;
            });

            setChallenges(loadedChallenges);
            setLoadedBoolean(true)

        }, 200);

        return () => clearTimeout(timer);
    }, []);


    //GET Refreshing Challenges
    const handleRefresh = async () => {
        const loadedChallenges = await getMyChallengesForUser(userID);
        loadedChallenges.sort((a, b) => {
            const dateA = new Date(a.datePosted.seconds * 1000);
            const dateB = new Date(b.datePosted.seconds * 1000);
            return dateB - dateA;
        });
        setChallenges(loadedChallenges);
    }
    const handleNavigateToChallenge = (challenge) => {
        setSelectedChallenge(challenge);
        navigate(`/challenge/${challenge.id}`);
    };


    // Edit Challenges Pop Up
    const [editPopUp, setEditPopUp] = useState(false)
    const handleEdit = () => {
        setEditPopUp(true)
    }
    const handleCloseEdit = () => {
        setEditPopUp(false)
        setDeleteChallenge(false)
        setChallengeToDeleteId(false)
        setDeleted(false)
    }


    //Deleting Challenge
    const [deleteChallenge, setDeleteChallenge] = useState(false)
    const [challengeToDeleteId, setChallengeToDeleteId] = useState(false)
    const handleDelete = (id) => {
        console.log(id)
        setEditPopUp(false)
        setDeleteChallenge(true)
        setChallengeToDeleteId(id)
    }
    const challengeToDeleteObject = challenges.find(challenge => challenge.id === challengeToDeleteId);
    const handleCancelDeleteThisChallenge = () => {
        setEditPopUp(true)
        setDeleteChallenge(false)
        setChallengeToDeleteId(false)
    }
    const [deleting, setDeleting] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const handleDeleteThisChallenge = async () => {
        try {
            setDeleting(true)
            await deleteMyChallenge(challengeToDeleteId)

            setDeleting(false)
            setDeleted(true)
        }
        catch (error) {
            console.error('Error deleteing challenge:', error);
        }
    }
    const handleCloseDelete = () => {
        setDeleteChallenge(false)
        setChallengeToDeleteId(false)
        setDeleted(false)
        handleRefresh()
    }

    // Add Challenge
    const [addChallengePopUp, setAddChallengePopUp] = useState(false)
    const handleAdd = () => {
        setAddChallengePopUp(true)
        console.log(true)
    }
    const handleCloseAddChallenge = () => {
        setAddChallengePopUp(false)
    }


    //Public Pop Up
    const [publicPopUp, setPublicPopUp] = useState(false)
    const [challengeToToggleIndex, setChallengeToToggleIndex] = useState(false)
    const handlePublicPopUp = (key) => {
        setChallengeToToggleIndex(key)
        console.log(key)
        setPublicPopUp(true)
    }
    const [toggling, setToggling] = useState(false)
    const [toggled, setToggled] = useState(false)
    const handleSaveChanges = async () => {
        try {
            setToggling(true);

            // Get the current challenge details
            const challengeId = challenges[challengeToToggleIndex].id;
            const updatedPublicFlag = challenges[challengeToToggleIndex].publicFlag;

            // Prepare the updated data object
            const updatedData = {
                publicFlag: updatedPublicFlag,
                approvedForPublic: true,
                featured: true,
            };

            // Call the Firebase update function
            await updateMyChallenge(challengeId, updatedData);

            setToggling(false);
            setToggled(true);
            console.log('Challenge updated successfully');
        } catch (error) {
            console.error('Error updating challenge:', error);
            setToggling(false);
        }
    };
    const handleClosePublicPopUp = () => {
        setChallengeToToggleIndex(false)
        setPublicPopUp(false)
        setToggling(false)
        setToggled(false)
    }
    const handleToggleLive = () => {
        setChallenges(prevChallenges => {
            // Create a new array with updated challenge
            return prevChallenges.map((challenge, index) => {
                // If the index matches the challengeToToggleIndex, toggle the publicFlag
                if (index === challengeToToggleIndex) {
                    return {
                        ...challenge,
                        publicFlag: !challenge.publicFlag // Toggle the value
                    };
                }
                // Return the challenge as is for all other indices
                return challenge;
            });
        });
    };


    return (
        <div>
            <Navbar option={4} />

            {/* Title & Buttons */}
            <div className='setion tight' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h1 style={{ textAlign: 'left', color: 'var(--fontlightblack1)' }}>My Challenges</h1>
                <Button text={'Add +'} option={'green'} onClick={handleAdd} />
            </div>

            {/* Add Challenge */}
            {
                addChallengePopUp === true ? (
                    <AddChallenge
                        userID={userID}
                        onClose={() => handleCloseAddChallenge()}
                        channelID={false}
                        onChallengeAdded={() => handleRefresh()}
                    />
                ) : null
            }

            {/* No of challenges label */}
            {
                !loadedBoolean ? (
                    <div className="section tight">
                        <p>Loading...</p>
                    </div>
                ) : (
                    initialChallenges.length > 0 ? (
                        <div className="section tight">
                            <div style={{ display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'space-between' }}>
                                <p style={{ textAlign: 'left' }}>Your challenges are available only to you.</p>
                                <Button text={'edit'} option={'button-linked-text'} onClick={handleEdit} />
                            </div>
                        </div>
                    ) : (
                        <div className="section tight">
                            <p style={{ textAlign: 'left' }}>Create your own challenges!</p>
                        </div>
                    )
                )
            }

            {/* Loading Circle */}
            {
                !loadedBoolean ? (
                    <div className="loading-circle"></div>
                ) : null
            }

            {/* My Challenges List */}
            {
                loadedBoolean ? (
                    <div style={{ marginTop: '40px' }} className="section tight">
                        {
                            challenges.map((challengeObject, index) => {

                                return (
                                    <MyChallenge
                                        key={index}
                                        imageURL={challengeObject.imageURL}
                                        videoURL={challengeObject.videoURL}
                                        title={challengeObject.title}
                                        eventTime={challengeObject.eventTime}
                                        eventsTotal={challengeObject.eventsTotal}
                                        weeks={challengeObject.weeks}
                                        subtitle={challengeObject.subtitle}
                                        about={challengeObject.about}
                                        onNavigate={() => handleNavigateToChallenge(challengeObject)}
                                        id={challengeObject.id}
                                        publicFlag={challengeObject.publicFlag}
                                        onPublicPopUp={() => handlePublicPopUp(index)}
                                    />
                                )

                            })
                        }
                    </div>
                ) : null
            }

            {/* Pop Up: Toggle to Pop Up */}
            {
                publicPopUp === true ? (
                    <div className="edit-challenges-pop-up-container">
                        <div className="edit-challenges-pop-up">
                            <div className="edit-challenges-pop-up-header">
                                <div className="title">
                                    <div />
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleClosePublicPopUp}>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="edit-challenges-pop-up-scroll-view"
                                style={{ marginTop: '20px' }}
                            >
                                <div style={{
                                    backgroundImage: `url(${challenges[challengeToToggleIndex].imageURL})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    aspectRatio: '1/1',
                                    height: '160px',
                                    borderRadius: '12px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }} />
                                <h3>{challenges[challengeToToggleIndex].title}</h3>
                                {
                                    challenges[challengeToToggleIndex].publicFlag === false ? (
                                        <div>
                                            <p style={{ color: 'var(--fontlightblack1)' }}>This challenge is set as <strong>private</strong>. It can only be viewed by you. To make it available to others, please toggle the switch below.</p>
                                            {/* <ToggleSwitch isOn={false} handleToggle={handleCloseEdit} /> */}
                                        </div>
                                    ) : (
                                        <div>
                                            <p style={{ color: 'var(--fontlightblack1)' }}>This challenge is set as <strong>public</strong>. To make it only avaialbel to yourself, please toggle the switch below.</p>
                                        </div>
                                    )
                                }
                                <ToggleSwitch
                                    isOn={challenges[challengeToToggleIndex].publicFlag}
                                    handleToggle={handleToggleLive}
                                />
                                {
                                    !toggling && (
                                        toggled ? (
                                            <div style={{ marginTop: '12px', display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                <Button text={'Close'} option={'button-linked-text'} onClick={handleClosePublicPopUp} />
                                            </div>
                                        ) : (
                                            <div style={{ marginTop: '12px', display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                <Button text={'Cancel'} option={'button-linked-text'} onClick={handleClosePublicPopUp} />
                                                <Button text={'Save'} option={'green'} onClick={handleSaveChanges} />
                                            </div>
                                        )
                                    )
                                }
                                {
                                    toggling ? (
                                        <div className="loading-circle"></div>
                                    ) : null
                                }
                                <div className="footer-margin">
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Edit */}
            {
                editPopUp === true ? (
                    <div className="edit-challenges-pop-up-container">
                        <div className="edit-challenges-pop-up">
                            <div className="edit-challenges-pop-up-header">
                                <div className="title">
                                    <h2>Your Challenges</h2>
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseEdit}>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="edit-challenges-pop-up-scroll-view"
                                style={{ marginTop: '20px' }}
                            >
                                {
                                    challenges.map((challengeObject) => {

                                        return (
                                            <div style={{ marginBottom: '12px' }}>
                                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${challengeObject.imageURL})`,
                                                            backgroundSize: 'cover',
                                                            backgroundPosition: 'center',
                                                            backgroundRepeat: 'no-repeat',
                                                            height: '80px',
                                                            width: '80px',
                                                            borderRadius: '12px'
                                                        }}
                                                    >
                                                    </div>
                                                    <div style={{ textAlign: 'left' }}>
                                                        <p style={{ margin: '0' }}>{challengeObject.title}</p>
                                                        <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>{formatFirestoreTimestamp(challengeObject.createdAt)}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'end', gap: '4px', marginLeft: 'auto', marginRight: '0' }} >
                                                        <SmallButton text={'delete'} option={'red'} onClick={() => handleDelete(challengeObject.id)} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div className="footer-margin">
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            }

            {/* Pop Up: Delete */}
            {
                deleteChallenge === true ? (
                    <div className="delete-challenge-pop-up-container">
                        <div className="delete-challenge-pop-up">
                            <div className="delete-challenge-pop-up-header">
                                <div className="title">
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleCloseEdit}
                                    />
                                </div>
                            </div>
                            {
                                deleting ? (
                                    <div className="delete-challenge-pop-up-scroll-view ">
                                        <p style={{ width: '100%', textAlign: 'center' }}>Deleting challenge...</p>
                                        <div className="my-challenge-details-delete-loading-circle"></div>
                                    </div>
                                ) : (
                                    deleted ? (
                                        <div className="delete-challenge-pop-up-scroll-view ">
                                            <p style={{ width: '100%', textAlign: 'center' }}>Challenge deleted</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleCloseDelete} />
                                        </div>
                                    ) : (
                                        <div className="delete-challenge-pop-up-scroll-view">
                                            <div
                                                style={{ width: '100%', textAlign: 'center' }}
                                                className='channel-description'
                                            >
                                                <p>Are you sure you want to <strong>delete this challenge</strong>?</p>
                                            </div>
                                            {
                                                // Render the found challenge, if it exists
                                                challengeToDeleteObject && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${challengeToDeleteObject.imageURL})`,
                                                                backgroundSize: 'cover',
                                                                backgroundPosition: 'center',
                                                                backgroundRepeat: 'no-repeat',
                                                                height: '80px',
                                                                width: '80px',
                                                                borderRadius: '12px'
                                                            }}
                                                        >
                                                        </div>
                                                        <div style={{ textAlign: 'left' }}>
                                                            <p style={{ margin: '0' }}>{challengeToDeleteObject.title}</p>
                                                            <p style={{ fontSize: 'small', fontWeight: '500', color: 'grey', margin: '0' }}>{formatFirestoreTimestamp(challengeToDeleteObject.createdAt)}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <div style={{ display: 'flex', gap: '12px', marginTop: '12px', marginBottom: '12px', justifyContent: "center" }}>
                                                <SmallButton text={'Cancel'} option={'yellow'} onClick={handleCancelDeleteThisChallenge} />
                                                <SmallButton text={'Delete'} option={'red'} onClick={handleDeleteThisChallenge} />
                                            </div>
                                            <p style={{ fontSize: 'small' }}>This challenge will be deleted from your challenges.</p>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                ) : (
                    null
                )
            }

            <div className="footer-margin">
            </div>
        </div >
    );
};

export default MyChallenges;